import { dispatch } from '../../application/appStore'
import { appDispatcher } from '../../application/AppDispatcher'
import { namespacedConsts } from '../../utils/object'

const CLASS_CONSTATNTS = namespacedConsts({
  ADS: {
    ACTIONS: {
      SLOT_HIDE: true,
      SLOT_RENDERED: true,
      ALL_SLOTS_RENDERED: true,
      AD_BLOCK_DETECTION_FINISHED: true,
      VIDEO_AD_STARTED: true,
      REQUESTING_ADS: true,
    },
  },
})

export const TYPES = CLASS_CONSTATNTS.ADS.ACTIONS

export const requestingAds = adType => {
  appDispatcher.dispatchAction.window({
    type: TYPES.REQUESTING_ADS,
    adType,
  })
}

export const slotHide = adId => {
  appDispatcher.dispatchAction.view({
    type: TYPES.SLOT_HIDE,
    adId,
  })
}

export const slotRendered = slotRenderedEvent => {
  const { adId, isAdEmpty: isEmpty, adRenderedEvent, size } = slotRenderedEvent
  appDispatcher.dispatchAction.view({
    type: TYPES.SLOT_RENDERED,
    adId,
    size,
    isEmpty,
    event: adRenderedEvent,
    dispatchToRedux: true,
    payload: { ...slotRenderedEvent },
  })
}

export const allSlotsRendered = events => {
  appDispatcher.dispatchAction.view({
    type: TYPES.ALL_SLOTS_RENDERED,
    events,
  })
}

export const adBlockDetectionFinished = state => {
  dispatch({
    type: TYPES.AD_BLOCK_DETECTION_FINISHED,
    state,
  })
}

export const videoAdStarted = payload => {
  appDispatcher.dispatchAction.external({
    type: TYPES.VIDEO_AD_STARTED,
    payload,
  })
}
export { CLASS_CONSTATNTS }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/adActions.js